// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen`.

import Ajv from "ajv";
import addFormats from "ajv-formats";
import call from "../../sdk-helpers/call";
import { logError } from "../../sdk-helpers/shouldLog";

export type typeStripsSpotReleaseBody = {
  poolId: string;
  eventId: string;
  stripNumber: number;
  row: number;
};

export type typeStripsSpotReleaseOutput200 = {
  error?: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data?: null | { stripNumber: number; row: number; mySpotCount: number };
};

export type typeStripsSpotReleaseOutput400 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeStripsSpotReleaseOutput401 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeStripsSpotReleaseOutput500 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export const schemaStripsSpotReleaseBody = {
  type: "object",
  properties: {
    poolId: { type: "string", maxLength: 3000, minLength: 1 },
    eventId: { type: "string", maxLength: 3000, minLength: 1 },
    stripNumber: { type: "integer" },
    row: { type: "integer" },
  },
  required: ["poolId", "eventId", "stripNumber", "row"],
} as const;

export type SdkOptions = {
  headers?: Record<string, string>;
  apiHost?: string;
  prefix?: string;
};

let compiledValidator: ReturnType<Ajv["compile"]> | null = null;

export default function createStripsSpotRelease(options: SdkOptions) {
  if (!compiledValidator) {
    const ajv = new Ajv({ strict: false });
    addFormats(ajv);
    compiledValidator = ajv.compile(schemaStripsSpotReleaseBody);
  }

  return async function postStripsSpotRelease(
    payload: typeStripsSpotReleaseBody,
  ): Promise<typeStripsSpotReleaseOutput200 | typeStripsSpotReleaseOutput400> {
    const isValid = compiledValidator!(payload);
    if (!isValid) {
      logError(
        `Payload validation inside SDK method "postStripsSpotRelease" failed before calling the network. #47b293437293`,
        compiledValidator!.errors,
      );
      return {
        error: {
          code: "VALIDATION_ERROR",
          message: "Request payload failed schema validation.",
          details: { errors: compiledValidator!.errors, ref: "#47b293437293" },
        },
        data: null,
      } as typeStripsSpotReleaseOutput400;
    }

    const prefix = options?.prefix ?? "";
    return (await call({
      payload,
      endpoint: `${prefix}/strips/spot-release`,
      httpMethod: "POST",
      options,
    })) as typeStripsSpotReleaseOutput200 | typeStripsSpotReleaseOutput400;
  };
}
